import { render, staticRenderFns } from "./insureProductNarrate.vue?vue&type=template&id=966248e6&scoped=true"
import script from "./insureProductNarrate.vue?vue&type=script&lang=js"
export * from "./insureProductNarrate.vue?vue&type=script&lang=js"
import style0 from "./insureProductNarrate.vue?vue&type=style&index=0&id=966248e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966248e6",
  null
  
)

export default component.exports